import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { Match, MatchPreference, MatchState, ProviderOverview, PublicUser, PublicUserProfile } from '../../resources';


export type UserMatchesOutput = {
  data: {
    matches: Match[];
    matchPreferences: MatchPreference[];
    users: PublicUser[];
    profiles: PublicUserProfile[];
    providerOverviews: ProviderOverview[];
  };
};


export const getUserMatches = (data: { userId: string; states?: MatchState[]; forceMatchCreateIfMissing?: boolean }) =>
  restClient.request<UserMatchesOutput>('/api/v1/matches/get_matches', {
    method: 'POST',
    data: snakecaseKeys(data),
  });
